import { chunk } from "./batchedIn";

/**
 * W136 B2 S3r4 W1 — THE LIBRARY READ A DRAWN WORKOUT MAKES FOR ITS EXERCISES, ONE FUNCTION (lifted out of the week column's
 * `useWeekTrees`, which made it for media and, since S3, for `tracking_fields`). The door (`assigned_workout_tree`) carries an
 * exercise's NAME only; a run's unit is its FIELD's (`distance_km` → `6 km`, never `6000 m`), so every surface that draws a
 * dose from the door reads the library rows here and hands `fields` to `workoutOverview`. The door does not change.
 *
 * ⚠️ BEST-EFFORT, ON PURPOSE: a refused or failed batch leaves its ids out of both maps — the dose falls back to metres (the
 * stored unit) and the picture to none, never a failed page. Chunked at `batchedIn`'s fifty.
 */
export const LIBRARY_ROWS_SELECT = "id, demo_video_url, thumbnail_url, tracking_fields, equipment";

type Row = { id: string; demo_video_url: string | null; thumbnail_url: string | null; tracking_fields: string[] | null;
  equipment?: string[] | null };

export type LibraryRows = {
  media: Map<string, { demo: string | null; thumb: string | null }>;
  fields: Map<string, readonly string[]>;
  /** QUEUE N2b-2 — each row's `equipment` keys, for the printed page's `Equipment:` line (`equipmentChips`' own input). */
  equipment: Map<string, readonly string[]>;
};

export async function readLibraryRows(
  select: (ids: string[]) => PromiseLike<{ data: unknown }>,
  ids: readonly string[],
): Promise<LibraryRows> {
  const media: LibraryRows["media"] = new Map();
  const fields: LibraryRows["fields"] = new Map();
  const equipment: LibraryRows["equipment"] = new Map();
  for (const part of chunk([...new Set(ids)])) {
    const { data } = await select(part);
    for (const row of (Array.isArray(data) ? data : []) as Row[]) {
      media.set(row.id, { demo: row.demo_video_url, thumb: row.thumbnail_url });
      fields.set(row.id, row.tracking_fields ?? []);
      equipment.set(row.id, row.equipment ?? []);
    }
  }
  return { media, fields, equipment };
}
